module.exports = __webpack_public_path__ + "static/img/hbys-02.30b15ed8.jpg";